import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ChainedBackend from 'i18next-chained-backend'
import Backend from 'i18next-http-backend'
import LocalStorageBackend from 'i18next-localstorage-backend'

const langFromLocalStorage = localStorage.getItem('activeLang')

i18n
  .use(ChainedBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: langFromLocalStorage || 'en',
    debug: process.env.NODE_ENV !== 'production',
    backend: {
      backends: [
        LocalStorageBackend,
        Backend
      ],
      backendOptions: [{
        expirationTime: 7 * 24 * 60 * 60 * 1000, // 7 days
        // Bump version to force LocalStorageBackend to reload updated translation.json files
        versions: { en: '1.0.44', es: '1.0.44', fr: '1.0.44', hi: '1.0.44', zh: '1.0.44', ar: '1.0.44' }
      }, {
        loadPath: '/locales/{{lng}}/{{ns}}.json'
      }]
    },
  })

export default i18n
